import { render, staticRenderFns } from "./edit-receipt-dialog.vue?vue&type=template&id=47c4f776&"
import script from "./edit-receipt-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-receipt-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports